module.exports = __webpack_public_path__ + "static/media/elephant.8176ddb5.svg";